(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-type', {
            parent: 'entity',
            url: '/sector-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-type/sector-types.html',
                    controller: 'SectorTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorType');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-type-detail', {
            parent: 'entity',
            url: '/sector-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-type/sector-type-detail.html',
                    controller: 'SectorTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorType');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorType', function($stateParams, SectorType) {
                    return SectorType.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-type.new', {
            parent: 'sector-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-type/sector-type-dialog.html',
                    controller: 'SectorTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                sectorTypeCategory: null,
                                isPrivate: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-type', null, { reload: true });
                }, function() {
                    $state.go('sector-type');
                });
            }]
        })
        .state('sector-type.edit', {
            parent: 'sector-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-type/sector-type-dialog.html',
                    controller: 'SectorTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorType', function(SectorType) {
                            return SectorType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-type.delete', {
            parent: 'sector-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-type/sector-type-delete-dialog.html',
                    controller: 'SectorTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorType', function(SectorType) {
                            return SectorType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
